var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { IdLang } from "../../utils/i18n/IdLang";
import { TypeActionLoca } from "./actionLoca";
var initial = {
    lang: IdLang.English,
};
export var reducerLoca = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionLoca.Change:
            return __assign({}, state, { lang: action.lang });
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/features/loca/reducerLoca.ts
// module id = 2546
// module chunks = 3